import { useMemo } from 'react';
import { Card } from '../components/Card';
import { Sparkline } from '../components/Sparkline';
import { TrendCard } from '../components/TrendCard';
import { useHealthData } from '../services/HealthDataContext';
import { getMetricSeries, getScoreHistory } from '../services/metrics';

export function TrendsScreen() {
  const { history, historyByDate, todayKey, trends } = useHealthData();

  const scoreHistory = useMemo(() => getScoreHistory(history, todayKey, 30), [history, todayKey]);
  const hrvSeries = useMemo(() => getMetricSeries(historyByDate, 'hrv', todayKey, 30).map((p) => p.value), [historyByDate, todayKey]);
  const sleepSeries = useMemo(
    () => getMetricSeries(historyByDate, 'sleepDuration', todayKey, 30).map((p) => p.value),
    [historyByDate, todayKey],
  );

  const readinessSeries = scoreHistory.map((point) => point.readinessScore);

  return (
    <div className="screen screen--trends">
      <Card title="Tendencias detectadas" subtitle="Basadas en tu historico, sin diagnosticos medicos">
        {trends.length === 0 ? (
          <p className="empty-state">No se detectaron tendencias relevantes en tus ultimos dias.</p>
        ) : (
          <div className="trend-card-list">
            {trends.map((trend) => (
              <TrendCard key={trend.id} trend={trend} />
            ))}
          </div>
        )}
      </Card>

      <Card title="Preparacion" subtitle="Ultimos 30 dias">
        <Sparkline values={readinessSeries} width={320} height={72} />
      </Card>

      <Card title="HRV" subtitle="Ultimos 30 dias">
        <Sparkline values={hrvSeries} width={320} height={64} color="var(--vt-accent-2)" />
      </Card>

      <Card title="Duracion de sueno" subtitle="Ultimos 30 dias">
        <Sparkline values={sleepSeries} width={320} height={64} />
      </Card>

      <p className="disclaimer">
        VitalAI identifica asociaciones en tus propios datos. Estas observaciones no constituyen un diagnostico
        medico.
      </p>
    </div>
  );
}
